(function() {
  var header = document.querySelector('.nso-h2');
  if (!header) return;

  // Mobile drawer
  var drawer = document.querySelector('[data-nso-drawer]');
  var toggleBtn = header.querySelector('[data-drawer-toggle]');
  var closeBtns = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    toggleBtn && toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggleBtn && toggleBtn.addEventListener('click', function() {
    var isOpen = drawer.getAttribute('data-open') === 'true';
    isOpen ? closeDrawer() : openDrawer();
  });

  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Search overlay toggle
  var searchToggle = header.querySelector('[data-search-toggle]');
  var searchOverlay = header.querySelector('[data-search-overlay]');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function() {
      var isOpen = searchOverlay.getAttribute('data-open') === 'true';
      searchOverlay.setAttribute('data-open', isOpen ? 'false' : 'true');
      if (!isOpen) {
        var input = searchOverlay.querySelector('input');
        input && input.focus();
      }
    });

    // Close search on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.getAttribute('data-open') === 'true') {
        searchOverlay.setAttribute('data-open', 'false');
      }
    });
  }

  // Desktop dropdown close on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nso-h2__nav')) {
      var openDropdowns = header.querySelectorAll('.nso-h2__dropdown[data-open="true"]');
      openDropdowns.forEach(function(d) { d.setAttribute('data-open', 'false'); });
    }
  });
})();